import { render } from "./MultiApartmentAboutPage.vue?vue&type=template&id=06343628"
import script from "./MultiApartmentAboutPage.vue?vue&type=script&lang=js"
export * from "./MultiApartmentAboutPage.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__